import {IEnterpriseState} from "../../interfaces";

export const initialEnterpriseState: IEnterpriseState = {
    enterpriseAccount: null,
    enterpriseBusiness: null,
    enterpriseBusinessUsers: null,
    enterpriseStations: null,
    enterpriseStationGeoIPs: [],
    enterpriseReseller: null
};

